<div class="mt-3 mx-3">
    <div class="my-3 d-flex">
      <h5 style="padding: 0; margin: 0;">AI Risk Assessment Report</h5>
      <span *ngIf="isSearch" class="ml-auto">
        <img style="cursor: pointer;" width="30px" src="assets/images/icons8-microsoft-excel.svg"
        alt="icon-excel" title="export excel" (click)="export()">
      </span>
      <span *ngIf="!isSearch" class="ml-auto">
        <img style="cursor: pointer;" width="30px" src="assets/images/icons8-microsoft-excel.svg"
        alt="icon-excel" title="export excel" style="filter:grayscale(100%);">
      </span>
    </div>
    <div class="card bg-n7 mb-3" #SearchFilter>
      <div class="card-body">
        <h6 class="p-0 m-0;">
          <a (click)="collapse.toggle()" [attr.aria-expanded]="!isCollapse" aria-controls="collapseExample">
            <fa-icon *ngIf="isCollapse" [icon]="faAngleDown" class="mr-1"></fa-icon>
            <fa-icon *ngIf="!isCollapse" [icon]="faAngleUp" class="mr-1"></fa-icon>
            Search Filters
          </a>
        </h6>
      <div class="mt-2 ml-4" id="search" #collapse="ngbCollapse" [(ngbCollapse)]="isCollapse">
        <div class="row mb-1">

          <div class="col-12 col-sm-6 col-lg-4" #itDepartment>
            <span class="font-weight-bold">IT Department</span>
            <form [formGroup]="form">
              <ng-select name="itDepartment" id="itDepartment" formControlName="deptId" (change)="onSelectDepartment()" 
               [ngClass]="{ 'is-invalid': f.deptId?.touched && f.deptId.errors?.required}" [(ngModel)]="defaultItDepartmentId">
                <ng-option disabled [value]="">--Select IT Department--</ng-option>
                <ng-option *ngFor="let itDept of itDepartments" [value]=itDept.deptID> {{itDept.deptName}}</ng-option>
              </ng-select>
            </form>
          </div>

          <div class="col-12 col-sm-6 col-lg-4" #service>
            <span class="font-weight-bold">Service Name</span>
            <form [formGroup]="form">
              <p-multiSelect 
                [options]="serviceByDeptId" 
                formControlName="serviceIds"
                [disabled]="!f.deptId.value"
                [style]="{'width':'100%','min-width':'100%'}"
                defaultLabel="Select Service" 
                optionLabel="serviceName" optionValue="componentId"
                display="chip">
              </p-multiSelect>
            </form>
          </div>

          <div class="col-12 col-sm-6 col-lg-4" #createdDate>
            <span class="font-weight-bold">Created Date</span>
            <form>
              <div class="form-group hidden">
                <div class="input-group">
                  <input name="createDatepicker" class="form-control d-none" ngbDatepicker
                    #createDatepicker="ngbDatepicker" [autoClose]="'outside'"
                    (dateSelect)="onCreateDateSelection($event)" [displayMonths]="2" [dayTemplate]="createdDay"
                    outsideDays="hidden" [startDate]="f.createdStartDate.value!" tabindex="-1">
                  <ng-template #createdDay let-date let-focused="focused">
                    <span class="custom-day" [class.focused]="focused" [class.range]="isCreateRange(date)"
                      [class.faded]="isCreateHovered(date) || isCreateInside(date)"
                      (mouseenter)="hoveredCreatedDate = date" (mouseleave)="hoveredCreatedDate = null">
                      {{ date.day }}
                    </span>
                  </ng-template>
                </div>
              </div>
              <div class="form-group">
                <div class="input-group">
                  <input #dpCreateFromDate class="form-control" placeholder="dd/mm/yyyy" name="dpCreateFromDate"
                    [value]="formatter.format(f.createdStartDate.value)"
                    (input)="inputDate('createdStartDate',f.createdStartDate.value, dpCreateFromDate.value)" disabled>
                  <span class="btn date-range-symbol">-</span>
                  <input #dpCreateToDate class="form-control" placeholder="dd/mm/yyyy" name="dpCreateToDate"
                    [value]="formatter.format(f.createdEndDate.value)"
                    (input)="inputDate('createdEndDate',f.createdEndDate.value, dpCreateToDate.value)" disabled>
                  <div class="input-group-append">
                    <button class="btn btn-outline-secondary" (click)="createDatepicker.toggle()" type="button">
                      <fa-icon [icon]="faCalendarAlt"></fa-icon>
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>

        </div>

        <div class="row mb-1">

          <div class="col-12 col-sm-6 col-lg-4" #approvedDate>
            <span class="font-weight-bold">Approved Date</span>
            <form>
              <div class="form-group hidden">
                <div class="input-group">
                  <input name="datepicker" class="form-control d-none" ngbDatepicker #datepicker="ngbDatepicker"
                    [autoClose]="'outside'" (dateSelect)="onApproveDateSelection($event)" [displayMonths]="2"
                    [dayTemplate]="approvedDay" outsideDays="hidden" [startDate]="f.approvedStartDate.value!" tabindex="-1">
                  <ng-template #approvedDay let-date let-focused="focused">
                    <span class="custom-day" [class.focused]="focused" [class.range]="isApproveRange(date)"
                      [class.faded]="isApproveHovered(date) || isApproveInside(date)" (mouseenter)="hoveredApprovedDate = date"
                      (mouseleave)="hoveredApprovedDate = null">
                      {{ date.day }}
                    </span>
                  </ng-template>
                </div>
              </div>
              <div class="form-group">
                <div class="input-group">
                  <input #dpFromDate class="form-control" placeholder="dd/mm/yyyy" name="dpFromDate"
                    [value]="formatter.format(f.approvedStartDate.value)"
                    (input)="inputDate('approvedStartDate',f.approvedStartDate.value, dpFromDate.value)" disabled >
                  <span class="btn date-range-symbol">-</span>
                  <input #dpToDate class="form-control" placeholder="dd/mm/yyyy" name="dpToDate"
                    [value]="formatter.format(f.approvedEndDate.value)"
                    (input)="inputDate('approvedEndDate',f.approvedEndDate.value, dpToDate.value)" disabled >
                  <div class="input-group-append">
                    <button class="btn btn-outline-secondary" (click)="datepicker.toggle()" type="button">
                      <fa-icon [icon]="faCalendarAlt"></fa-icon>
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>

          <div class="col-12 col-sm-6 col-lg-4" #aiRiskResult>
            <span class="font-weight-bold">ผลการประเมินความเสี่ยงจากการใช้ AI </span>
            <form [formGroup]="form">
              <ng-select name="aiRiskResult" id="aiRiskResult" formControlName="aiRiskResult" placeholder="Select AI Risk Result"> >
                <ng-option disabled [value]="">--Select AI Risk Result--</ng-option>
                <ng-option *ngFor="let a of aiRiskResults" [value]=a.aiRiskLevel> {{a.aiRiskLevelLabel}}</ng-option>
              </ng-select>
            </form>
          </div>

        </div>
        
        <div class="d-flex justify-content-end mt-3">
          <button class="btn btn-link mr-2" type="button" (click)="clear()">Clear Filter</button>
          <button class="btn btn-primary" type="button" (click)="search()">Search</button>
        </div>
      </div>
    </div>  
  </div>

  <div  #Table>
    <div class="d-flex justify-content-end my-3">
      <app-row-per-page [size]=pageSize (newSize)="updatePageSize($event)">
      </app-row-per-page>
    </div>
    <div class="table-responsive" #servicesTable>
      <table mat-table class="table table-hover" cdk-table [dataSource]="tasks">
  
        <ng-container cdkColumnDef="type">
          <th class="table-header-cell align-content-center" cdk-header-cell *cdkHeaderCellDef>Type</th>
          <td class="table-cell border text-center" cdk-cell *cdkCellDef="let element">{{element.taskCategory}}</td>
        </ng-container>
    
        <ng-container cdkColumnDef="taskID">
          <th class="table-header-cell border-left" cdk-header-cell *cdkHeaderCellDef>Task ID</th>
          <td class="table-cell border" cdk-cell *cdkCellDef="let element">{{element.formattedTaskId}}</td>
        </ng-container>

        <ng-container cdkColumnDef="mainTaskName">
          <th class="table-header-cell border-left align-content-center" cdk-header-cell *cdkHeaderCellDef>Main Task Name</th>
          <td class="table-cell" cdk-cell *cdkCellDef="let element">
            <a [href]="'/task/detail/' + element.taskId + '/' + element.status + '/' + element.taskCategoryId + '?isReadonly=true'" target="_blank">{{element.taskName}}</a>
          </td>
        </ng-container>

        <ng-container cdkColumnDef="serviceName">
          <th class="table-header-cell border-left align-content-center" cdk-header-cell *cdkHeaderCellDef>Service Name</th>
          <td class="table-cell border" cdk-cell *cdkCellDef="let element">{{element.service}}</td>
        </ng-container>

        <ng-container cdkColumnDef="itDepartment">
          <th class="table-header-cell border-left" cdk-header-cell *cdkHeaderCellDef>IT Department</th>
          <td class="table-cell text-center border" cdk-cell *cdkCellDef="let element">{{element.itDepartmentName}}</td>
        </ng-container>
  
        <ng-container cdkColumnDef="category1">
          <th class="table-header-cell text-center border-left align-content-center" cdk-header-cell *cdkHeaderCellDef>หมวดที่ 1 : ประเภทของข้อมูล + ระดับการควบคุม</th>
          <td class="table-cell text-center border" cdk-cell *cdkCellDef="let element">{{ element.aiRiskDataAndControl?.aiRiskLevelLabel || '' }}</td>
        </ng-container>

        <ng-container cdkColumnDef="category2">
          <th class="table-header-cell text-center border-left align-content-center" cdk-header-cell *cdkHeaderCellDef>หมวดที่ 2 : ลักษณะการใช้งาน AI</th>
          <td class="table-cell text-center border" cdk-cell *cdkCellDef="let element">{{ element.aiRiskUsage?.aiRiskLevelLabel || '' }}</td>
        </ng-container>

        <ng-container cdkColumnDef="aiRiskResult">
          <th class="table-header-cell text-center border-left align-content-center" cdk-header-cell *cdkHeaderCellDef>ผลการประเมินความเสี่ยงจากการใช้ AI</th>
          <td class="table-cell text-center border" cdk-cell *cdkCellDef="let element">{{element.aiRiskResultLabel}}</td>
        </ng-container>

          <ng-container cdkColumnDef="aiRiskStatus">
          <th class="table-header-cell border-left align-content-center" cdk-header-cell *cdkHeaderCellDef>Status</th>
          <td class="table-cell border" cdk-cell *cdkCellDef="let element">{{element.aiRiskStatusLabel}}</td>
        </ng-container>

          <ng-container cdkColumnDef="approvedDate">
          <th class="table-header-cell border-left align-content-center" cdk-header-cell *cdkHeaderCellDef>Approved Date</th>
          <td class="table-cell border" cdk-cell *cdkCellDef="let element">{{element.aiRiskApproveDate}}</td>
        </ng-container>

        <ng-container cdkColumnDef="createdDate">
          <th class="align-items-center table-header-cell border-left align-content-center" cdk-header-cell *cdkHeaderCellDef>Creatd Date</th>
          <td class="table-cell border" cdk-cell *cdkCellDef="let element">{{element.createdDate}}</td>
        </ng-container>
  
        <tr class="table-header" cdk-header-row *cdkHeaderRowDef="reportColumn"></tr>
        <tr class="table-row" cdk-row *cdkRowDef="let row; columns: reportColumn" [class.hidden]="tasks.length > 0"></tr> 
      </table>  
  
  
      <div class="not-found text-center" *ngIf="tasks.length === 0" >
        <div class="my-3"> No Task found.</div>
      </div>
  
    </div>
  
    <div class="bg-black-haze">
      <div class="align-self-center">
        <ngb-pagination class="d-flex justify-content-end pt-3 pr-2" [collectionSize]="totalElements"
          [(page)]="page" [maxSize]="5" [boundaryLinks]="true" [pageSize]="pageSize"
          (pageChange)="updatePage()">
        </ngb-pagination>
      </div>
    </div>
    
  </div>
    
</div>
